import React from 'react';
import PropTypes from 'prop-types';

import loc from 'sources/locale/loc';
import classnames from 'classnames';
import styles from './AdminUsersList.scss';
import AdminUsersListItem from './AdminUsersListItem';

export default function AdminUsersList(props) {
  const { items, onUpdateItem } = props;
  return (
    <ul className={styles.list}>
      <li className={classnames(styles.container, styles.header)} key="header">
        <div className={styles.avatar} />
        <div className={styles.name}>{loc('name')}</div>
        <div className={styles.email}>{loc('email')}</div>
        <div className={styles.dob}>{loc('dob')}</div>
        <div className={styles.gender}>{loc('gender')}</div>
        <div className={styles.genderPreferences}>
          {loc('genderPreferences')}
        </div>
        <div className={styles.reports}>{loc('reports')}</div>
        <div className={styles.actions} />
      </li>
      {items.map(item => (
        <AdminUsersListItem
          key={item.id}
          item={item}
          onUpdateItem={onUpdateItem}
        />
      ))}
    </ul>
  );
}

AdminUsersList.propTypes = {
  items: PropTypes.array,
  onUpdateItem: PropTypes.func.isRequired,
};

AdminUsersList.defaultProps = {
  items: [],
};



// WEBPACK FOOTER //
// ./src/components/Admin/UsersList/AdminUsersList.jsx